(() => {
  if (window.ljWorldsBound) return;
  window.ljWorldsBound = true;
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-lj-world-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.ljWorldOpen);
      if (dialog && !dialog.open) {
        dialog.showModal();
        dialog.addEventListener('close', () => open.focus({preventScroll:true}), {once:true});
      }
      return;
    }
    const close = event.target.closest('[data-lj-world-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.lj-world-dialog')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
    }
  });
})();
